import {tns} from 'tiny-slider/src/tiny-slider.module';
import MobileDetect from 'mobile-detect/mobile-detect';

class Orders {
    constructor() {
            let _this = this,
                orderSliders =  $('ul[id^="orderSlider"]'),
                findTotalElements = orderSliders.length,
                mobileDetector =  new MobileDetect(window.navigator.userAgent),
                isPhone = mobileDetector.phone(),
                isTablet = mobileDetector.tablet()
            ;

            this.defaultSliderTotalItems = isPhone ? 2 : isTablet ? 3 : 4;

            for (let i=0; findTotalElements > i; i++) {
                let $orderSlider = $(orderSliders[i]),
                     id = $orderSlider.attr('id'),
                     firstElement
                ;
                if (id.length > 0) {
                    let totalSubElements = $orderSlider.find('li').length,
                        allowSlider = totalSubElements > this.defaultSliderTotalItems,
                        slider = this.initSlider(id, $orderSlider, allowSlider, totalSubElements);
                    if (slider) {
                        const info = slider.getInfo();
                        if (!allowSlider) {
                            $(info.controlsContainer).find('button').remove();
                        }
                    } else {
                        firstElement = $orderSlider.find('li:first');
                        if (firstElement.length === 0) {
                            $orderSlider.append('<li style="width: 100px">&nbsp;</li>');
                        }
                        $orderSlider.find('li:first').clone(true).appendTo($orderSlider);
                        const oneElementSlider = this.initSlider(id, $orderSlider, false, 1);
                        const info = oneElementSlider.getInfo();
                        $(info.controlsContainer).find('button').remove();
                    }
                }
            }
        }

        initSlider(id, $orderSlider, allowSlider, totalSubElements) {
            return tns({
                container: '#' + id,
                items: allowSlider ? this.defaultSliderTotalItems : totalSubElements,
                loop: true,
                controlsText: [
                    `<svg class="icon-chevron-left">
                        <use xlink:href="svg/icons.svg#icon-chevron-left"></use>
                    </svg>`,
                    `<svg class="icon-chevron-right">
                        <use xlink:href="svg/icons.svg#icon-chevron-right"></use>
                    </svg>`
                ],
                speed: 500,
                onInit: function () {
                    $orderSlider.removeClass('invisible');
                }
            });
        }
}

$(document).ready(function () {
    let orders = new Orders();
});
